import {Box, Center, Heading, Image, Text, VStack} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

import {Button} from '../../components/Button/Button';
import {i18n} from '../../i18n/i18n';

export function ErrorPage(props: TestIdProps) {
  return (
    <Box backgroundColor="general.accent" height="100vh">
      <Center height="100%">
        <Box maxWidth={180} padding={6}>
          <VStack spacing={6} align="center">
            <Image
              src="./assets/images/logo.svg"
              alt="VIN Decoder"
              width={38}
              data-testid={suffixTestId('logo', props)}
            />
            <Heading size={1} align="center" data-testid={suffixTestId('error', props)}>
              {i18n.t('page.error.labels.errorMessage')}
            </Heading>
            <Text align="center" data-testid={suffixTestId('error', props)}>
              {i18n.t('page.error.labels.errorMessageDescription')}
            </Text>
            <Button
              title={i18n.t('page.error.labels.errorButton')}
              onClick={() => window.location.reload()}
              variant="outline"
              size="small"
              data-testid={suffixTestId('error', props)}
            />
          </VStack>
        </Box>
      </Center>
    </Box>
  );
}
